/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchTenantsResponseItem } from './search-tenants-response-item';

export interface SearchTenantsResponseItemPagedList {
  totalCount?: number;
  items?: Array<SearchTenantsResponseItem> | null;
}
